import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useRef, useState, useImperativeHandle, useCallback, useEffect } from 'react';
import { PageFlip } from 'page-flip';
var HTMLFlipBookForward = React.forwardRef(function (props, ref) {
  var htmlElementRef = useRef(null);
  var childRef = useRef([]);
  var _pageFlip = useRef();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    pages = _useState2[0],
    setPages = _useState2[1];
  useImperativeHandle(ref, function () {
    return {
      pageFlip: function pageFlip() {
        return _pageFlip.current;
      }
    };
  });
  var refreshOnPageDelete = useCallback(function () {
    if (_pageFlip.current) {
      _pageFlip.current.clear();
    }
  }, []);
  var removeHandlers = useCallback(function () {
    var flip = _pageFlip.current;
    if (flip) {
      flip.off('flip');
      flip.off('changeOrientation');
      flip.off('changeState');
      flip.off('init');
      flip.off('update');
    }
  }, []);
  useEffect(function () {
    childRef.current = [];
    if (props.children) {
      var childList = React.Children.map(props.children, function (child) {
        return React.cloneElement(child, {
          ref: function ref(dom) {
            if (dom) {
              childRef.current.push(dom);
            }
          }
        });
      });
      if (!props.renderOnlyPageLengthChange || pages.length !== childList.length) {
        if (childList.length < pages.length) {
          refreshOnPageDelete();
        }
        setPages(childList);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.children]);
  useEffect(function () {
    var setHandlers = function setHandlers() {
      var flip = _pageFlip.current;
      if (flip) {
        if (props.onFlip) {
          flip.on('flip', function (e) {
            return props.onFlip(e);
          });
        }
        if (props.onChangeOrientation) {
          flip.on('changeOrientation', function (e) {
            return props.onChangeOrientation(e);
          });
        }
        if (props.onChangeState) {
          flip.on('changeState', function (e) {
            return props.onChangeState(e);
          });
        }
        if (props.onInit) {
          flip.on('init', function (e) {
            return props.onInit(e);
          });
        }
        if (props.onUpdate) {
          flip.on('update', function (e) {
            return props.onUpdate(e);
          });
        }
      }
    };
    if (pages.length > 0 && childRef.current.length > 0) {
      removeHandlers();
      if (htmlElementRef.current && !_pageFlip.current) {
        _pageFlip.current = new PageFlip(htmlElementRef.current, props);
      }
      if (!_pageFlip.current.getFlipController()) {
        _pageFlip.current.loadFromHTML(childRef.current);
      } else {
        _pageFlip.current.updateFromHtml(childRef.current);
      }
      setHandlers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages]);
  return React.createElement("div", {
    ref: htmlElementRef,
    className: props.className,
    style: props.style
  }, pages);
});
var HTMLFlipBook = React.memo(HTMLFlipBookForward);
export default HTMLFlipBook;